import { render, staticRenderFns } from "./SmartAgentProfile.vue?vue&type=template&id=49b79d8c&scoped=true"
import script from "./SmartAgentProfile.vue?vue&type=script&lang=js"
export * from "./SmartAgentProfile.vue?vue&type=script&lang=js"
import style0 from "./SmartAgentProfile.vue?vue&type=style&index=0&id=49b79d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b79d8c",
  null
  
)

export default component.exports